module.exports = __webpack_public_path__ + "static/media/11.1bcd6b54.jpg";